let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("OHoOf")).then(() => parcelRequire('14875'));